export default __webpack_public_path__ + "static/media/weather.df09e87c.jpg";